<template>
	<div>
		<div class="back-icon" @click="onBack">
			<img src="@/assets/annualReport/back.png" />
		</div>
	</div>
</template>

<script>
	import { isCottiApp } from "@/utils/index.js";

	export default {
		data() {
			return {};
		},
		methods: {
			onBack() {
				if (isCottiApp()) {
					GoBack.postMessage('');
				} else {
					window.history.back();
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.back-icon {
		width: 64px;
		height: 64px;
		background: rgba(0, 0, 0, 0.15);
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		> img {
			width: 64px;
			height: 64px;
		}
	}
</style>
